module.exports = __webpack_public_path__ + "img/equipment-item-2.b1bc182.png";